<template>
  <div>
    <a-form style="margin:30px 10px 10px 10px;flex: 1;">
      
      <a-form-item v-if="!formData.isFenxiao"
                   label="规格信息"
                   :labelCol="labelCol"
                   :wrapperCol="wrapperCol"
      >
        
        <div style="margin: 10px 0;" v-for="(field,k) in sku_fields_list" :key="'k'+k">
          <div>
            <a-popconfirm okText="确定" cancelText="取消" @confirm="editField(field.id, k)">
              <template slot="title">
                <div style="width: 220px;">
                  <a-input
                          v-model="fieldEditValue"
                          placeholder="规格名称（中文）"
                          style="margin-bottom: 8px;"/>
                  <a-input
                          v-model="fieldEditValueEn"
                          placeholder="English name"/>
                </div>
              </template>
              <a-button
                style="margin: 0 10px 0 0 "
                type="primary"
                @click="prepareEditField(field)"
              >{{field.title}}<span v-if="field.title_en" style="opacity:.8"> / {{field.title_en}}</span>
              </a-button>

            </a-popconfirm>
            <a-popconfirm title="此操作将永久删除该规格及相关库存价格信息, 是否继续?" @confirm="deleteField(k)" okText="确定"
                          cancelText="取消">
              <a-icon
                      class="dynamic-delete-button"
                      type="minus-circle-o"
              />
            </a-popconfirm>
          </div>
          
          <div style="margin: 10px 0">
            <a-badge v-for="(attr,k2) in field.attrs" :key="'k2'+k2" style="margin-right: 20px;">
              <a-icon slot="count" type="close-circle" style="color: #f5222d" @click="deleteOption(k,k2)"/>
              <a-popconfirm okText="确定" cancelText="取消" @confirm="editOption(attr.id, k, k2)">
                <template slot="title">
                  <div style="width: 220px;">
                    <a-input
                            v-model="attrEditValue"
                            placeholder="属性名称（中文）"
                            style="margin-bottom: 8px;"/>
                    <a-input
                            v-model="attrEditValueEn"
                            placeholder="English name"/>
                  </div>
                </template>
                <a-button @click="prepareEditAttr(attr)">
                  {{attr.title}}<span v-if="attr.title_en" style="opacity:.8"> / {{attr.title_en}}</span>
                </a-button>
              </a-popconfirm>

              <pic-uploader v-if="k==0"  :numberLimit="1" :file-list="attr.pic" />
            </a-badge>
            <a-popconfirm okText="确定" cancelText="取消" @confirm="addOption(k)">
              <span slot="icon"/>
              <template slot="title">
                <div style="width: 220px;">
                  <a-input
                          v-model="attrSelectValue"
                          placeholder="属性名称（中文）"
                          style="margin-bottom: 8px;"/>
                  <a-input
                          v-model="attrSelectValueEn"
                          placeholder="English name"/>
                </div>
              </template>
              <a-button type="dashed">新增属性</a-button>
            </a-popconfirm>
          
          </div>
        
        
        </div>
        <a-popconfirm okText="确定" cancelText="取消" @confirm="addField">
          <span slot="icon"/>
          <template slot="title">
            <div style="width: 220px;">
              <a-input
                      v-model="fieldSelectValue"
                      placeholder="规格名称（中文）"
                      style="margin-bottom: 8px;"/>
              <a-input
                      v-model="fieldSelectValueEn"
                      placeholder="English name"/>
            </div>
          </template>
          <a-button icon="plus" type="primary">新增规格</a-button>
        </a-popconfirm>
      
      </a-form-item>
      
      <a-table :columns="columns" :scroll="{x:900 }" :dataSource="skuTable.sku_list" :pagination="false" rowKey="key" bordered>
          
        <template slot="customPrice">
          <a-popconfirm okText="确定" cancelText="取消" @confirm="setAllPrice">
            <span slot="icon"/>
            <template slot="title">
              <PriceInput :formData="setAll"
                          field="setAllPriceValue"
                          placeholder="批量设置价格"/>
            </template>
            价格
            <a-icon type="form"/>
          </a-popconfirm>
        </template>
        <template slot="insidePrice">
          <a-popconfirm okText="确定" cancelText="取消" @confirm="setAllInsidePrice">
            <span slot="icon"/>
            <template slot="title">
              <PriceInput :formData="setAll"
                          field="setAllInsidePriceValue"
                          placeholder="批量设置内供价格"/>
            </template>
            内供价格
            <a-icon type="form"/>
          </a-popconfirm>
        </template>
        <template slot="customStock">
            库存<br/>允许负库存?
          <a-popconfirm okText="确定" cancelText="取消" @confirm="setAllStatus">
            <span slot="icon"/>
            <template slot="title">
                允许负库存
                <r-switch :formData="setAll" field="setAllStatusValue" :checkedValue="1" :unCheckedValue="2" checkedChildren="开启"
                          unCheckedChildren="关闭"/>
            </template>
            <!-- 库存 -->
            <a-icon v-if="!formData.isFenxiao" type="form"/>
          </a-popconfirm>
        </template>
        <template slot="customUnit">
          <a-popconfirm okText="确定" cancelText="取消" @confirm="setAllUnit">
            <span slot="icon"/>
            <template slot="title">
              <a-input
                      v-model="setAllUnitValue"
                      type="number"
                      placeholder="批量设置件数"/>
            </template>
            件数
            <a-icon v-if="!formData.isFenxiao" type="form"/>
          </a-popconfirm>
        </template>
        <template slot="customCostPrice">
          <a-popconfirm okText="确定" cancelText="取消" @confirm="setAllCostPrice">
            <span slot="icon"/>
            <template slot="title">
              <PriceInput :formData="setAll"
                          field="setAllCostPriceValue"
                          placeholder="批量设置成本价"/>
            </template>
            成本
            <a-icon v-if="!formData.isFenxiao" type="form"/>
          </a-popconfirm>
        </template>

        <template slot="customWarningStock">
          <a-popconfirm okText="确定" cancelText="取消" @confirm="setAllWCostPrice">
            <span slot="icon"/>
            <template slot="title">
              <PriceInput :formData="setAll"
                          field="setAllWarningStockValue"
                          placeholder="批量设置预警值"/>
            </template>
            预警值
            <a-icon v-if="!formData.isFenxiao" type="form"/>
          </a-popconfirm>
        </template>
        <template slot="id" slot-scope="text,record,index">
          <a-input v-model="record.id" placeholder="id"/>
        </template>
        <template slot="price" slot-scope="text,record,index">
          <PriceInput :formData="record"
                      field="price"
                      placeholder="价格"/>
        </template>
        <template slot="inside_price" slot-scope="text,record,index">
          <PriceInput :formData="record"
                      field="inside_price"
                      placeholder="价格"/>
        </template>
        <template slot="stock" slot-scope="text,record,index">
          <!-- <a-popconfirm okText="确定" cancelText="取消" @confirm="setStock(record,setStockCountValue)"
                        v-if="!formData.isFenxiao">
            <span slot="icon"/>
            <template slot="title" v-if="!formData.isFenxiao">
              正数为加库存,负数为减库存<br/>
              <a-input
                      style="width: 200px; margin: 10px 0 0 0"
                      type="number"
                      v-model="setStockCountValue"
                      placeholder="请输入调整数量"/>
            </template>
            {{record.stock}}
          </a-popconfirm> -->
          <!-- <span v-else> -->
              {{record.stock}}
    <br />
    <r-switch :formData="record" field="status" :checkedValue="1" :unCheckedValue="2" checkedChildren="开启"
                          unCheckedChildren="关闭"/>
              <!-- </span> -->
        </template>
        <template slot="unit_count" slot-scope="text,record,index">
          <a-input type="number" placeholder="请输入件数" v-model="record.unit_count"
                   :disabled='formData.isFenxiao'></a-input>
        </template>
        <template slot="cost_price" slot-scope="text,record,index">
          <PriceInput :formData="record"
                      field="cost_price"
                      placeholder="请输入成本价格" :disabled='formData.isFenxiao'/>
        </template>
        <template slot="sold_count" slot-scope="text,record,index">
          <span>{{record.sold_count}}</span>
        </template>
        <template slot="warning_stock" slot-scope="text,record,index">
          <a-input type="number" placeholder="请输入预警值" v-model="record.warning_stock"
                   :disabled='formData.isFenxiao'></a-input>
        </template>
        
        <template slot="code" slot-scope="text,record,index">
          <a-textarea
            v-model="record.code"
            change="onTextAreaChange"
            placeholder="输入代码"
            :auto-size="{ minRows: 3, maxRows: 5 }"
            />
        </template>
        <span slot="express_tpl_id" slot-scope="text,record">
        <template>
          <a @click="onSelectExpress(record)" v-if="!record.express_tpl_id">选择运费模板</a>
          <a @click="onSelectExpress(record)" v-else>已选择</a>
        </template>
      </span>
      </a-table>
      
      
      <a-affix :offsetBottom="0">
        <div style="background: #fff; padding: 10px 0 20px 0 ; border-top: 1px solid #eee  ">
          <a-button style="margin-right: 10px" @click="prevStep">上一步</a-button>
          <a-button style="margin-right: 10px" :loading="saveLoading" type="primary" @click="submitForm">保存&下一步</a-button>
          <a-button @click="nextStep">下一步</a-button>
        </div>
      </a-affix>
    
    </a-form>
    
    <a-modal
        :maskClosable="false" title="选择运费模板" v-model="expressVisible" @ok="expressVisible=false" :width="850"
             :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}">
      <a-form style="margin:30px 10px 10px 10px;flex: 1;">
        <a-form-item
                label="运费模板"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
        >
          <a-select
                  showSearch
                  allowClear
                  v-model="skuRow.express_tpl_id"
                  optionFilterProp="title"
                  placeholder="选择运费模板"
          >
            <a-select-option
                    :key="option.id"
                    v-for="option in expressTplOptions"
                    :title="option.title"
                    :value="option.id"
            >{{option.title}}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
    import PriceInput from '@/components/PriceInput/'
    import {
        getFieldList,
        getAttrList,
        skuFieldAdd,
        skuFieldEdit,
        skuAttrAdd,
        skuAttrEdit,
        skuFieldDelete,
        skuAttrDelete,
        skuDetail,
        stockSetInc,
        skuEdit
    } from '@/api/goods'
    import {getExpressTplOptions} from '@/api/express'
    import RSwitch from '@/components/RSwitch/'
    import PicUploader from "@/components/PicUploader/";

    export default {
        name: 'Step2',
        props: {
            goodsId: null,
            currentTab: null,
        },
        components: {
            PriceInput,RSwitch,PicUploader,
        },
        data() {
            return {
                saveLoading: false,
                expressVisible: false,
                disabled: true,
                labelCol: {
                    xs: {span: 24},
                    sm: {span: 2},
                },
                wrapperCol: {
                    xs: {span: 24},
                    sm: {span: 16},
                },
                setStockCountValue: 0,
                fieldSelectOptions: [],
                attrSelectValue: '',
                attrSelectValueEn: '',
                attrEditValue: '',
                attrEditValueEn: '',
                popoverFieldAddVisible: false,
                attrSelectOptions: [],
                expressTplOptions: [],
                fieldSelectValue: '',
                fieldSelectValueEn: '',
                fieldEditValue: '',
                fieldEditValueEn: '',
                columns2: [],
                sku_fields_list: [],
                formData: {
                    goods_id: 0,
                    sku_fields: [],
                    sku: []
                },
                skuTable: {
                    sku_fields_sets: [],
                    sku_list: [],
                },
                setAll: {
                    setAllPriceValue: '',
                    setAllCostPriceValue: '',
                    setAllInsidePriceValue:'',
                    setAllWarningStockValue:'',
                    setAllStatusValue:2
                },
                setAllStockValue: '',
                setAllUnitValue: '',
                skuRow: {}
            }
        },
        watch: {
            currentTab(newVal) {
                if (newVal == 1) {
                    let that = this;
                    that.formData.goods_id = that.goodsId;
                    that.fetch();
                }
            }
        },
        computed: {
            onTextAreaChange(e){
                console.log(e.detail)
                console.log(this.skuTable)
            },
            columns() {
                let self = this;
                let skuColums = [];
                self.sku_fields_list.map((item, index) => {
                    if (item.attrs.length == 0) {
                        return;
                    }
                    skuColums.push({
                        title: '' + item.title,
                        width: 100,
                        dataIndex: 'sku[' + index + '].attr_title',
                        customRender: (value, row, index2) => {
                            const obj = {
                                children: value,
                                attrs: {},
                            };
                            let rowSpan = self.skuTable.sku_fields_sets[index][0].height;
                            if (index2 % rowSpan == 0) {
                                obj.attrs.rowSpan = rowSpan;
                            } else {
                                obj.attrs.rowSpan = 0;
                            }
                            return obj;
                        }
                    });
                });
                let constColums = [
                    {
                        width: 100,
                        dataIndex: 'price',
                        slots: {title: 'customPrice'},
                        scopedSlots: {customRender: 'price'}
                    },
                    // 本项目不需要：内供价格 / 库存 / 预警值
                    {
                        width: 80,
                        slots: {title: 'customUnit'},
                        dataIndex: 'unit_count',
                        scopedSlots: {customRender: 'unit_count'}
                    },
                    {
                        width: 80,
                        slots: {title: 'customCostPrice'},
                        dataIndex: 'cost_price',
                        scopedSlots: {customRender: 'cost_price'}
                    },
                    
                    {
                        title: '销量',
                        width: 70,
                        dataIndex: 'sold_count',
                        scopedSlots: {customRender: 'sold_count'},
                    },
                    {
                        title: '代码',
                        width: 150,
                        dataIndex: 'code',
                        scopedSlots: {customRender: 'code'},
                    },
                    {
                        title: '运费模板',
                        width: 130,
                        dataIndex: 'express_tpl_id',
                        scopedSlots: {customRender: 'express_tpl_id'},
                    }
                ];
                return skuColums.concat(constColums);
            }
        },
        mounted() {
            let that = this;
            if (that.goodsId) {
                that.formData.goods_id = that.goodsId;
                that.fetch();
            }
        },
        methods: {
            fetch() {
                let that = this;
                skuDetail({
                    'goods_id': that.goodsId
                }).then(res => {
                    that.formData = res.data;
                    console.log(that.formData)
                    that.sku_fields_list = res.data.sku_fields_list;
                    that.refreshSkuList();
                }).catch(err => {
                })

                getExpressTplOptions().then(res => {
                    that.expressTplOptions = res.data
                })

            },

            onSelectExpress(record) {
                console.log('onSelectExpress', record)
                let that = this
                that.expressVisible = true
                that.skuRow = record
            },

            refreshSkuList() {
                let self = this;
                var sets = [];
                var skulist = [];
                var count = [];
                if (this.sku_fields_list.length == 0 || this.sku_fields_list[0].attrs.length == 0) {
                    // self.skuTable.sku = []
                    self.skuTable = {
                        sku_fields_sets: sets,
                        sku_list: skulist,
                    }
                    return {
                        'sku_fields_sets': sets,
                        'sku_list': skulist,
                    }
                }
                for (var i = this.sku_fields_list.length - 1; i >= 0; i--) {
                    var key = this.sku_fields_list.length - 1 - i;
                    var rkey = i;
                    var list = [];
                    var len = this.sku_fields_list[i].attrs.length;
                    if (i - 1 >= 0) {
                        count[i - 1] = len * (count[i] ? count[i] : 1);
                    }

                    sets[key] = [];
                    if (key == 0) {
                        for (var l = 0; l < this.sku_fields_list[key].attrs.length; l++) {
                            sets[key].push({
                                'id': this.sku_fields_list[key].attrs[l].id,
                                'title': this.sku_fields_list[key].attrs[l].title,
                                'sku': [{
                                    'field_id': this.sku_fields_list[key].id,
                                    'attr_id': this.sku_fields_list[key].attrs[l].id,
                                    'attr_title': this.sku_fields_list[key].attrs[l].title,
                                }]
                            })
                        }
                    } else {
                        var ccount = sets[key - 1].length;
//                        console.log('ccount');
//                        console.log(ccount);
                        for (var n = 0; n < ccount; n++) {
                            for (var j = 0; j < this.sku_fields_list[key].attrs.length; j++) {
                                var sku = sets[key - 1][n]['sku'];
                                sets[key].push(
                                    {
                                        'id': this.sku_fields_list[key].attrs[j].id,
                                        'title': this.sku_fields_list[key].attrs[j].title,
                                        'sku': sku.concat({
                                            'field_id': this.sku_fields_list[key].id,
                                            'attr_id': this.sku_fields_list[key].attrs[j].id,
                                            'attr_title': this.sku_fields_list[key].attrs[j].title,
                                        })
                                    }
                                )
                            }
//                            sets[key] = sets[key].concat(this.sku_fields_list[key].attrs);
                        }
//                        console.log('set');
//                        console.log(sets[key]);
                    }
                }

                for (var k = 0; k < sets.length; k++) {
                    for (var index = 0; index < sets[k].length; index++) {
                        sets[k][index].height = count[k] ? count[k] : 1;
                    }
                }
                if (sets[sets.length - 1].length == 0) {
                    sets.splice(sets.length - 1, 1);
                }

                console.log('sets[sets.length-1]', sets[sets.length - 1])
                for (var m = 0; m < sets[sets.length - 1].length; m++) {
                    var row = {
                        'key': 'm' + m,
                        'id': 0,
                        'code': '',
                        'price': 0,
                        'inside_price':0,
                        'cost_price': 0,
                        'status': 1,
                        'sold_count': 0,
                        'warning_stock':100,
                        'unit_count': 1,
                        'stock': 0,
                        'popoverVisible': false,
                        'sku': sets[sets.length - 1][m].sku,
                        'height': sets[sets.length - 1][m].height
                    };
                    for (var p = 0; p < this.formData.sku.length; p++) {
                        let skuArray = [];
                        sets[sets.length - 1][m].sku.map(skuItem => {
                            skuArray.push({
                                field_id: skuItem.field_id,
                                attr_id: skuItem.attr_id,
                            })
                        });
                        console.log('skuArray');
                        console.log(skuArray);
                        if (JSON.stringify(this.formData.sku[p].sku).replace(/"/g, '') == JSON.stringify(skuArray).replace(/"/g, '')) {
                            row = {
                                'key': 'p' + p,
                                'id': this.formData.sku[p].id,
                                'code': this.formData.sku[p].code,
                                'price': this.formData.sku[p].price,
                                'inside_price': this.formData.sku[p].inside_price,
                                'cost_price': this.formData.sku[p].cost_price,
                                'status': this.formData.sku[p].status,
                                'sold_count': this.formData.sku[p].sold_count,
                                'warning_stock': this.formData.sku[p].warning_stock,
                                'unit_count': this.formData.sku[p].unit_count,
                                'stock': this.formData.sku[p].stock,
                                'express_tpl_id': this.formData.sku[p].express_tpl_id,
                                'popoverVisible': false,
                                'sku': sets[sets.length - 1][m].sku,
                                'height': sets[sets.length - 1][m].height
                            };
                            break;
                        }
                    }
                    skulist.push(row);
                }
                console.log('skulist')
                console.log(skulist)
                self.skuTable = {
                    sku_fields_sets: sets,
                    sku_list: skulist,
                }
            },

            prepareEditField(field) {
                this.fieldEditValue = field.title || '';
                this.fieldEditValueEn = field.title_en || '';
            },
            prepareEditAttr(attr) {
                this.attrEditValue = attr.title || '';
                this.attrEditValueEn = attr.title_en || '';
            },
            addField() {
                let that = this;
                if (that.formData.isFenxiaos == true) {
                    that.$message.error('正在被分销的商品不能修改sku配置');
                    return
                }
                skuFieldAdd({
                    title: that.fieldSelectValue,
                    title_en: that.fieldSelectValueEn,
                    goods_id: that.goodsId
                }).then(res => {
                    that.sku_fields_list.push({
                        'id': res.data.id,
                        'title': that.fieldSelectValue,
                        'title_en': that.fieldSelectValueEn,
                        'attrs': []
                    });
                    that.fieldSelectValue = '';
                    that.fieldSelectValueEn = '';
                    that.refreshSkuList();
                }).catch(err => {
                    that.fieldSelectValue = '';
                    that.fieldSelectValueEn = '';
                    that.$message.error(err.data.msg);
                })
            },
          // 修改规格名称
          editField(fieldId, index) {
            let that = this;
            skuFieldEdit({
              title: that.fieldEditValue,
              title_en: that.fieldEditValueEn,
              goods_id: that.goodsId,
              field_id: fieldId
            }).then(res => {
              that.sku_fields_list[index].title = that.fieldEditValue
              that.sku_fields_list[index].title_en = that.fieldEditValueEn
              that.fieldEditValue = '';
              that.fieldEditValueEn = '';
              that.refreshSkuList();
            }).catch(err => {
              that.fieldEditValue = '';
              that.fieldEditValueEn = '';
              that.$message.error(err.data.msg);
            })
          },
            deleteField(index) {
                let that = this;
                if (that.formData.isFenxiaos == true) {
                    that.$message.error('正在被分销的商品不能修改sku配置');
                    return
                }
                that.$confirm({
                    title: '提示',
                    content: '此操作将永久删除该规格及相关库存价格信息,是否继续?',
                    onOk() {

                        skuFieldDelete({
                            'id': that.sku_fields_list[index].id
                        }).then(res => {
                            that.sku_fields_list.splice(index, 1);
                            that.refreshSkuList();
                        }).catch(err => {
                        })
                    },
                    onCancel() {

                    },
                });

            },
            addOption(k) {
                let that = this;
                if (that.formData.isFenxiaos == true) {
                    that.$message.error('正在被分销的商品不能修改sku配置');
                    return
                }
                skuAttrAdd({
                    'field_id': that.sku_fields_list[k].id,
                    'title': that.attrSelectValue,
                    'title_en': that.attrSelectValueEn,
                    'pic':[]
                }).then(res => {
                    that.sku_fields_list[k].attrs.push({
                        'id': res.data.id,
                        'title': that.attrSelectValue,
                        'title_en': that.attrSelectValueEn,
                        'pic':[]
                    });
                    that.attrSelectValue = '';
                    that.attrSelectValueEn = '';
                    that.refreshSkuList();
                }).catch(err => {
                    that.attrSelectValue = '';
                    that.attrSelectValueEn = '';
                    that.$message.error(err.data.msg);
                })
            },
            // 修改规格属性名称
            editOption(attrId,k, k2) {
              let that = this;
              skuAttrEdit({
                'field_id': that.sku_fields_list[k].id,
                'attr_id': attrId,
                'title': that.attrEditValue,
                'title_en': that.attrEditValueEn
              }).then(res => {
                that.sku_fields_list[k].attrs[k2].title = that.attrEditValue;
                that.sku_fields_list[k].attrs[k2].title_en = that.attrEditValueEn;
                that.attrEditValue = '';
                that.attrEditValueEn = '';
                that.refreshSkuList();
                // that.getScorllWidth()
              }).catch(err => {
                that.attrEditValue = '';
                that.attrEditValueEn = '';
                that.$message.error(err.data.msg);
              })
            },
            deleteOption(index1, index2) {
                let that = this;
                if (that.formData.isFenxiaos == true) {
                    that.$message.error('正在被分销的商品不能修改sku配置');
                    return
                }
                console.log(index1, index2);
                that.$confirm({
                    title: '提示',
                    content: '此操作将永久删除该规格及相关库存价格信息,是否继续?',
                    onOk() {
                        skuAttrDelete({
                            'id': that.sku_fields_list[index1].attrs[index2].id
                        }).then(res => {
                            that.sku_fields_list[index1].attrs.splice(index2, 1);
                            that.refreshSkuList();
                        }).catch(err => {
                        })
                    },
                    onCancel() {

                    },
                });

            },
            getFieldOptions(query) {
                console.log(query);
                if (!query) {
                    return;
                }
                let that = this;
                that.fieldSelectOptions = [{
                    title: query,
                    id: -1,
                }];
                getFieldList({
                    'keywords': query
                })
                    .then(res => {
                        that.fieldSelectOptions = that.fieldSelectOptions.concat(res.data.filter(item => {
                            return item.title != query
                        }));
                    })
            },
            getAttrOptions(query) {
                console.log(query);
                if (!query) {
                    return;
                }
                let that = this;
                that.attrSelectOptions = [{
                    title: query,
                    id: -1,
                }];
                getAttrList()
                    .then(res => {
                        that.attrSelectOptions = that.attrSelectOptions.concat(res.data.filter(item => {
                            return item.title != query
                        }));
                    })
            },

            //批量设置价格
            setAllPrice() {
                let that = this;
                that.skuTable.sku_list.map(item => {
                    item.price = that.setAll.setAllPriceValue;
                });
                that.setAll.setAllPriceValue = '';
            },
            setAllInsidePrice(){
                let that = this;
                that.skuTable.sku_list.map(item => {
                    item.inside_price = that.setAll.setAllInsidePriceValue;
                });
                that.setAll.setAllInsidePriceValue = '';
            },
            //批量设置时候负库存
            setAllStatus(){
                let that = this;
                that.skuTable.sku_list.map(item => {
                    item.status = that.setAll.setAllStatusValue;
                }); 
            },
            //批量设置件数
            setAllUnit() {
                let that = this;
                that.skuTable.sku_list.map(item => {
                    item.unit_count = that.setAllUnitValue;
                });
                that.setAllUnitValue = '';
            },
            //批量设置库存
            setAllStock(setStockValue) {
                let that = this;
                that.setAllStockValue = '';
                that.skuTable.sku_list.map(v => {
                    that.setStock(v, setStockValue)
                });
            },
            //批量设置成本
            setAllCostPrice() {
                let that = this;
                console.log('setAllCostPrice')
                that.skuTable.sku_list.map(item => {
                    item.cost_price = that.setAll.setAllCostPriceValue;
                });
                that.setAll.setAllCostPriceValue = '';
            },
            //批量设置成本
            setAllWCostPrice() {
                let that = this;
                that.skuTable.sku_list.map(item => {
                    item.warning_stock = that.setAll.setAllWarningStockValue;
                });
                that.setAll.setAllWarningStockValue = '';
            },

            setStock(v, setStockValue) {
                let that = this;
                that.setStockCountValue = 0;
//        console.log(v);
                if (v.id > 0) {
                    //ajax
                    stockSetInc({
                        id: v.id,
                        inc: setStockValue
                    })
                        .then(res => {
                            v.stock = res.data.stock;
//              that.$message.success('设置成功');
                        }).catch(err => {
                        that.$message.error(err.data.msg);
                    })
                } else {
                    if (parseInt(v.stock) + parseInt(setStockValue) < 0) {
                        that.$message.error('库存不能小于0');
                        return;
                    }
                    v.stock = parseInt(v.stock) + parseInt(setStockValue);
                }
            },
            submitForm(formName) {
                const that = this;
                that.saveLoading = true;
                skuEdit({
                    'goods_id': that.goodsId,
                    'sku_fields_list': JSON.stringify(that.sku_fields_list),
                    'sku_list': JSON.stringify(that.skuTable.sku_list),
                }).then(res => {
                    that.$message.success('保存成功');
                    that.saveLoading = false;
                    that.nextStep()
                }).catch(err => {
                    that.$message.error(err.data.msg);
                    that.saveLoading = false;
                })
            },
            nextStep() {
                const that = this
                setTimeout(function () {
                    that.$emit('nextStep')
                }, 1)
            },
            prevStep() {
                this.$emit('prevStep')
            }
        }
    }
</script>

<style lang="less" scoped>
  .stepFormText {
    margin-bottom: 24px;
    
    .ant-form-item-label,
    .ant-form-item-control {
      line-height: 22px;
    }
  }

</style>